/* EPOXIUM pages: neon switch and colour, layer spread on scroll, size guide, table of contents. */
(() => {
  const root = document.querySelector('[data-epx]');
  if (!root) return;
  const $ = (s, r = root) => r.querySelector(s);
  const $$ = (s, r = root) => [...r.querySelectorAll(s)];
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const KEY = 'epx-neon';

  /* Neon colour: relights the whole page; remembered per visitor. */
  const colours = $$('[data-colours] button');
  const setColour = (btn) => {
    colours.forEach((b) => b.setAttribute('aria-checked', b === btn));
    root.style.setProperty('--neon', btn.dataset.colour);
    try { localStorage.setItem(KEY, btn.dataset.colour); } catch (e) {}
  };
  colours.forEach((btn, i) => {
    btn.addEventListener('click', () => setColour(btn));
    btn.addEventListener('keydown', (e) => {
      const d = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
      if (!d) return;
      e.preventDefault();
      const next = colours[(i + d + colours.length) % colours.length];
      setColour(next);
      next.focus();
    });
  });
  try {
    const saved = localStorage.getItem(KEY);
    const match = saved && colours.find((b) => b.dataset.colour === saved);
    if (match) setColour(match);
  } catch (e) {}

  /* Switch: on/off with a short ignition flicker. */
  const sw = $('[data-switch]');
  const face = $('[data-sign-face]');
  const label = $('[data-switch-label]');
  if (sw && face) {
    sw.addEventListener('click', () => {
      const on = sw.getAttribute('aria-checked') !== 'true';
      sw.setAttribute('aria-checked', on);
      label.textContent = on ? label.dataset.on : label.dataset.off;
      face.classList.toggle('is-on', on);
      if (on && !reduce) {
        face.classList.remove('is-flicker');
        void face.offsetWidth;
        face.classList.add('is-flicker');
      }
    });
    // First ignition when the page opens.
    if (!reduce) {
      face.classList.remove('is-on');
      setTimeout(() => face.classList.add('is-on', 'is-flicker'), 350);
    }
  }

  /* Layers: spread apart as the section scrolls through the viewport. */
  const layers = $('[data-layers]');
  if (layers) {
    const items = $$('[data-layer-label]', layers);
    const sticky = window.matchMedia('(min-width: 961px)');
    let ticking = false;
    const update = () => {
      ticking = false;
      let p;
      if (sticky.matches) {
        const r = layers.getBoundingClientRect();
        p = Math.min(1, Math.max(0, -r.top / (r.height - window.innerHeight)));
      } else {
        const r = layers.getBoundingClientRect();
        p = Math.min(1, Math.max(0, (window.innerHeight - r.top) / (window.innerHeight + r.height * 0.4)));
      }
      const spread = reduce ? 70 : Math.round(p * 90);
      layers.style.setProperty('--spread', spread);
      const active = reduce ? 4 : Math.min(4, Math.floor(p * 4.4) + 1);
      items.forEach((li, i) => li.classList.toggle('is-active', i < active));
    };
    const onScroll = () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    };
    // Horizon scrolls inside .page-wrapper, not the window: listen to every scroll.
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  /* Size guide. */
  const size = $('[data-size]');
  if (size) {
    const input = $('[data-size-input]', size);
    const sign = $('[data-size-sign]', size);
    const w = $('[data-size-w]', size);
    const h = $('[data-size-h]', size);
    const set = () => {
      const v = Number(input.value);
      sign.style.setProperty('--w', v);
      w.textContent = `${v} cm`;
      h.textContent = `${Math.round(v * 0.6)} cm`;
      input.style.setProperty('--p', `${((v - 50) / 150) * 100}%`);
    };
    input.addEventListener('input', set);
    set();
  }

  /* Table of contents from the page's own headings. */
  const toc = $('[data-toc]');
  const article = $('[data-article]');
  if (toc && article) {
    const heads = $$('h2, h3', article);
    if (heads.length >= 2) {
      const list = $('ol', toc);
      const slug = (t) => t.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      heads.forEach((hd, i) => {
        if (!hd.id) hd.id = `${slug(hd.textContent) || 'sec'}-${i}`;
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = `#${hd.id}`;
        a.textContent = hd.textContent;
        li.append(a);
        list.append(li);
      });
      toc.hidden = false;
      const links = $$('a', toc);
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((en) => {
            if (!en.isIntersecting) return;
            links.forEach((a) => a.classList.toggle('is-active', a.getAttribute('href') === `#${en.target.id}`));
          });
        },
        { rootMargin: '-20% 0px -70% 0px' }
      );
      heads.forEach((hd) => io.observe(hd));
    }
  }
})();
